import React, { useEffect } from "react";
import Navbar from "../common/Navbar";

const TermsConditionsPage = () => {
  useEffect(() => {
    document.title = "Terms & Conditions - ProSlay";
  }, []);

  return (
    <>
      <Navbar />
      <div
        className="container py-5 px-3"
        style={{ maxWidth: "900px", color: "#1a1a1a" }}
      >
        <h1 className="fw-bold text-center display-3 my-5" id="main-font">
          Terms and Conditions & Legal Disclaimer
        </h1>

        <section className="mb-4">
          <h3 className="fw-bold mb-2 display-5" id="main-font">
            1. Introduction
          </h3>
          <p>
            Welcome to ProSlay, an AI-powered litigation support platform
            designed to assist individuals in drafting legal documents for
            self-representation. By accessing or using this website and its
            related services, you agree to be bound by the following Terms and
            Conditions and Legal Disclaimers. Please read them carefully before
            proceeding.
          </p>
        </section>

        <section className="mb-4">
          <h3 className="fw-bold mb-2 display-5" id="main-font">
            2. Eligibility
          </h3>
          <p>
            You must be at least 18 years old to access or use ProSlay. By using
            this platform, you affirm that you are legally eligible to enter
            into binding contracts and represent yourself in court without the
            assistance of an attorney.
          </p>
        </section>

        <section className="mb-4">
          <h3 className="fw-bold mb-2 display-5" id="main-font">
            3. Scope of Services
          </h3>
          <p>
            ProSlay is not a law firm, we are NOT attorneys, and we do not
            provide legal advice, representation, or advocacy in any official
            capacity. Our services are limited to offering:
          </p>
          <ul>
            <li>AI-assisted tools for generating legal motion drafts;</li>
            <li>
              Templates and guided prompts to assist in court document creation;
            </li>
            <li>Optional human review for clarity and formatting.</li>
          </ul>
          <p>
            We do not handle criminal matters, nor do we prepare or support any
            filings related to criminal cases, including but not limited to
            arrests, indictments, or criminal trials.
          </p>
        </section>

        <section className="mb-4">
          <h3 className="fw-bold mb-2 display-5" id="main-font">
            4. No Attorney-Client Relationship
          </h3>
          <p>
            Use of ProSlay does not create an attorney-client relationship.
            Communications through our platform are not protected by
            attorney-client privilege. No user should rely on any information
            provided through this site as a substitute for legal counsel.
          </p>
        </section>

        <section className="mb-4">
          <h3 className="fw-bold mb-2 display-5" id="main-font">
            5. User Responsibilities
          </h3>
          <p>By using ProSlay, you agree to:</p>
          <ul>
            <li>
              Use the platform solely for lawful civil self-representation
              purposes;
            </li>
            <li>Provide truthful, accurate, and complete information;</li>
            <li>
              Accept full responsibility for all content entered, generated, or
              filed using our tools;
            </li>
            <li>Not share or misrepresent another person’s legal situation;</li>
            <li>
              Not use ProSlay in any manner that violates local, state, or
              federal law.
            </li>
          </ul>
        </section>

        <section className="mb-4">
          <h3 className="fw-bold mb-2 display-5" id="main-font">
            6. Guarantee and Refund Policy
          </h3>
          <p>
            ProSlay offers a limited performance-based satisfaction guarantee
            for eligible users.
          </p>
          <p>
            If your motion is denied solely on legal or procedural grounds
            despite full and accurate information being submitted, and you meet
            all eligibility requirements (see below), we may issue a refund upon
            review.
          </p>
          <p>This guarantee does not apply if:</p>
          <ul>
            <li>You provide false or incomplete facts;</li>
            <li>
              The loss results from clear legal wrongdoing, misconduct, or
              criminal liability;
            </li>
            <li>
              You fail to file or serve the document properly, appear in court,
              or follow procedural steps;
            </li>
            <li>
              You abandon the case voluntarily or do not cooperate with the
              ProSlay process.
            </li>
          </ul>
          <p>
            Refunds will be determined solely at the discretion of ProSlay upon
            case-specific review and are not automatic. Chargebacks without
            prior review are considered a violation of this agreement.
          </p>
        </section>

        <section className="mb-4">
          <h3 className="fw-bold mb-2 display-5" id="main-font">
            7. Intellectual Property
          </h3>
          <p>
            All software, designs, logos, processes, text, and data within
            ProSlay are the intellectual property of ProSlay or its creators.
            You may not reproduce, redistribute, or modify any part of the
            platform without explicit written permission.
          </p>
        </section>

        <section className="mb-4">
          <h3 className="fw-bold mb-2 display-5" id="main-font">
            8. Limitation of Liability
          </h3>
          <p>To the fullest extent permitted by law:</p>
          <ul>
            <li>
              ProSlay disclaims all warranties, express or implied, including
              but not limited to the effectiveness of legal outcomes.
            </li>
            <li>
              ProSlay is not liable for any damages—direct, indirect,
              incidental, special, or consequential—arising from your use of the
              platform or any services rendered.
            </li>
            <li>
              Total liability for any claims shall not exceed the total amount
              paid by the user for the specific service at issue.
            </li>
          </ul>
        </section>

        <section className="mb-4">
          <h3 className="fw-bold mb-2 display-5" id="main-font">
            9. Indemnification
          </h3>
          <p>
            You agree to indemnify, defend, and hold harmless ProSlay, its
            founders, agents, and partners from any claims, liabilities, losses,
            or expenses arising out of your use of the service, your violation
            of these terms, or your infringement of any rights of a third party.
          </p>
        </section>

        <section className="mb-4">
          <h3 className="fw-bold mb-2 display-5" id="main-font">
            10. Third-Party Content
          </h3>
          <p>
            ProSlay may link to external websites or content. We do not control
            or endorse third-party sites and are not responsible for their
            practices or content.
          </p>
        </section>

        <section className="mb-4">
          <h3 className="fw-bold mb-2 display-5" id="main-font">
            11. Modifications
          </h3>
          <p>
            We reserve the right to update or revise these Terms and Disclaimers
            at any time. Changes will be posted on this page, and continued use
            of the platform constitutes acceptance of the new terms.
          </p>
        </section>

        <section className="mb-4">
          <h3 className="fw-bold mb-2 display-5" id="main-font">
            12. Governing Law and Jurisdiction
          </h3>
          <p>
            These Terms and Conditions shall be governed by and construed in
            accordance with the laws of the United States, and where applicable,
            the State of New Jersey, without regard to its conflict-of-law
            principles.
          </p>
          <p>By using this site, you agree that:</p>
          <ul>
            <li>
              Any disputes arising from your use of the platform shall be
              subject to the exclusive jurisdiction of the state and federal
              courts located in New Jersey, unless otherwise required by
              applicable law in your jurisdiction;
            </li>
            <li>
              Users outside the United States agree to comply with all
              applicable local laws and regulations and acknowledge that
              ProSlay’s services are primarily governed by U.S. legal standards.
            </li>
          </ul>
          <p className="display-5" id="main-font">
            Nothing in this provision shall restrict ProSlay’s ability to seek
            injunctive or equitable relief in any jurisdiction where such relief
            is deemed necessary.
          </p>
        </section>

        <section className="mb-4">
          <h3 className="fw-bold mb-2 display-5" id="main-font">
            13. Contact Us
          </h3>
          <p>
            For inquiries, concerns, or to request a refund review, please
            contact us at:
          </p>
          <a
            className="display-5"
            id="main-font"
            href="mailto:jaime@mikrobank.com"
          >
            info@proslay.com
          </a>
        </section>
      </div>
    </>
  );
};

export default TermsConditionsPage;
